import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  action?: ReactNode;
  className?: string;
}

export default function SectionHeading({
  title,
  action,
  className = "mb-6",
}: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-wrap items-end justify-between gap-4 ${className}`}
    >
      <h2 className="m-0 text-2xl font-medium sm:text-[28px]">{title}</h2>
      {action}
    </div>
  );
}
